'use client';

import icon1 from '@/assets/images/product-tester-page/icon-1.svg';
import icon2 from '@/assets/images/product-tester-page/icon-2.svg';
import icon3 from '@/assets/images/product-tester-page/icon-3.svg';

import checkIcon from '@/assets/images/common/check.svg';

import applyImage from '@/assets/images/product-tester-page/apply.png';
import { useRef } from 'react';

import Image from 'next/image';
import Link from 'next/link';

import bannerImage from '@/assets/images/product-tester-page/banner.png';
import bannerImageMobile from '@/assets/images/product-tester-page/mobile-banner.png';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

const ProductTesterPage = () => {
  const containerRef = useRef(null);
  let isDragging = false;
  let startX;
  let scrollLeft;

  const handleMouseDown = e => {
    isDragging = true;
    containerRef.current.style.cursor = 'grabbing';
    containerRef.current.style.userSelect = 'none'; // 禁用文本选择
    startX = e.pageX - containerRef.current.offsetLeft;
    scrollLeft = containerRef.current.scrollLeft;
  };

  const handleMouseLeave = () => {
    isDragging = false;
    containerRef.current.style.cursor = 'grab';
    containerRef.current.style.userSelect = ''; // 恢复文本选择
  };

  const handleMouseUp = () => {
    isDragging = false;
    containerRef.current.style.cursor = 'grab';
    containerRef.current.style.userSelect = ''; // 恢复文本选择
  };

  const handleMouseMove = e => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - containerRef.current.offsetLeft;
    const walk = (x - startX) * 2; // 滚动速度

    containerRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <div className='pb-[80px]'>
      <Image
        src={bannerImageMobile}
        className='block h-auto w-full lg_hidden'
        alt=''
        priority
      />
      <Image
        src={bannerImage}
        className='hidden h-auto w-full lg_block'
        alt=''
        priority
      />

      <div className='block bg-[#EFEFEF] p-[20px] lg_hidden'>
        <h1 className='font-poppins text-[30px] font-[700] uppercase text-title'>Become a kingsyard product tester </h1>
        <p className='mt-[10px] font-sans text-title'>
          Join our tester program to receive new birding products, share your feedback, and help us grow together.
        </p>
      </div>

      <div className='mx-auto w-[1100px] max-w-full pt-[40px] lg_pt-[80px]'>
        <h2 className='pl-[15px] font-poppins text-[22px] font-[600] text-title lg_pl-0 lg_text-[30px]'>
          What&apos;s In It For You
        </h2>
        <div className='mx-[15px] mt-[20px] lg_hidden'>
          <div
            id='scroll-container'
            ref={containerRef}
            onMouseDown={handleMouseDown}
            onMouseLeave={handleMouseLeave}
            onMouseUp={handleMouseUp}
            onMouseMove={handleMouseMove}
            className='flex overflow-x-auto whitespace-nowrap pb-[20px]'
          >
            <div className='mr-[20px] flex min-h-[274px] w-[300px] shrink-0 flex-col items-center justify-center rounded-[5px] bg-[#F7F7F5] px-[20px] lg_px-[45px]'>
              <Image
                src={icon1}
                className=''
                alt=''
              />
              <p className='mt-[20px] font-poppins text-[18px] font-[600] text-title'>Free Early Access Products</p>
              <p className='mt-[10px] whitespace-normal text-center font-sans text-title'>
                Test our lateer feeders and accessories before anyone else.
              </p>
            </div>
            <div className='mr-[20px] flex min-h-[274px] w-[300px] shrink-0 flex-col items-center justify-center rounded-[5px] bg-[#F7F7F5] px-[20px] lg_px-[45px]'>
              <Image
                src={icon2}
                className=''
                alt=''
              />
              <p className='mt-[20px] font-poppins text-[18px] font-[600] text-title'>Influence Product Design </p>
              <p className='mt-[10px] whitespace-normal text-center font-sans text-title'>
                Your feedback helps shape our future products.{' '}
              </p>
            </div>
            <div className='flex min-h-[274px] w-[300px] shrink-0 flex-col items-center justify-center rounded-[5px] bg-[#F7F7F5] px-[20px] lg_px-[45px]'>
              <Image
                src={icon3}
                className=''
                alt=''
              />
              <p className='mt-[20px] font-poppins text-[18px] font-[600] text-title'>Exclusive Rewards </p>
              <p className='mt-[10px] whitespace-normal text-center font-sans text-title'>
                Enjoy gifts, discounts, and free testing oppotunnities.{' '}
              </p>
            </div>
          </div>
        </div>

        <div className='mt-[40px]  hidden grid-cols-3 gap-[24px] lg_grid'>
          <div className='flex min-h-[320px] flex-col items-center justify-center rounded-[5px] bg-[#F7F7F5] px-[45px]'>
            <Image
              src={icon1}
              className=''
              alt=''
            />
            <p className='mt-[20px] font-poppins text-[18px] font-[600] text-title'>Free Early Access Products</p>
            <p className='mt-[10px] text-center font-sans text-title'>
              Test our lateer feeders and accessories before anyone else.
            </p>
          </div>
          <div className='flex min-h-[320px] flex-col items-center justify-center rounded-[5px] bg-[#F7F7F5] px-[45px]'>
            <Image
              src={icon2}
              className=''
              alt=''
            />
            <p className='mt-[20px] font-poppins text-[18px] font-[600] text-title'>Influence Product Design </p>
            <p className='mt-[10px] text-center font-sans text-title'>
              Your feedback helps shape our future products.{' '}
            </p>
          </div>
          <div className='flex min-h-[320px] flex-col items-center justify-center rounded-[5px] bg-[#F7F7F5] px-[45px]'>
            <Image
              src={icon3}
              className=''
              alt=''
            />
            <p className='mt-[20px] font-poppins text-[18px] font-[600] text-title'>Exclusive Rewards </p>
            <p className='mt-[10px] text-center font-sans text-title'>
              Enjoy gifts, discounts, and free testing oppotunnities.{' '}
            </p>
          </div>
        </div>
      </div>

      <div className='mx-auto mt-[40px] flex max-w-full flex-col lg_mt-[80px] lg_w-[1100px] lg_flex-row'>
        <div className='flex-1 lg_bg-[#F7F7F5] lg_py-[40px] lg_pl-[40px] lg_pr-[70px]'>
          <h2 className='pl-[15px] font-poppins text-[22px] font-[600] text-title  lg_pl-0 lg_text-[30px]'>
            What We Expect from You
          </h2>

          <Image
            src={applyImage}
            className='mt-[20px] h-auto w-full lg_hidden'
            alt=''
          />

          <ul className='mt-[20px] flex flex-col gap-[20px] px-[15px] lg_gap-[10px] lg_px-0'>
            <li className='flex items-center justify-start font-sans text-sm text-title lg_text-[16px]'>
              <Image
                src={checkIcon}
                className='mr-[10px] h-[20px] w-[20px] lg_h-[30px] lg_w-[30px]'
                alt=''
              />
              Use the product for at least 2 weeks
            </li>
            <li className='flex items-center justify-start font-sans text-sm text-title lg_text-[16px]'>
              <Image
                src={checkIcon}
                className='mr-[10px] h-[20px] w-[20px] lg_h-[30px] lg_w-[30px]'
                alt=''
              />
              Submit honest written feedback{' '}
            </li>
            <li className='flex items-center justify-start font-sans text-sm text-title lg_text-[16px]'>
              <Image
                src={checkIcon}
                className='mr-[10px] h-[20px] w-[20px] lg_h-[30px] lg_w-[30px]'
                alt=''
              />
              Share photos or videos of your experience{' '}
            </li>
            <li className='flex items-center justify-start font-sans text-sm text-title lg_text-[16px]'>
              <Image
                src={checkIcon}
                className='mr-[10px] h-[20px] w-[20px] lg_h-[30px] lg_w-[30px]'
                alt=''
              />
              Post a review on our site or social platforms{' '}
            </li>
          </ul>

          <Link
            href='https://tally.so/r/mY9WKq'
            className='mx-[15px] mt-[20px] block h-[40px] rounded-[10px] bg-primary text-center font-poppins text-sm font-[600] uppercase leading-[40px] text-white hover_opacity-90 lg_mx-0 lg_mt-[40px] lg_h-[54px] lg_w-full lg_text-[16px] lg_leading-[54px]'
            target='_blank'
          >
            Apply Now
          </Link>
        </div>
        <div className='hidden flex-1 lg_block'>
          <Image
            src={applyImage}
            className='h-full w-full'
            alt=''
          />
        </div>
      </div>

      <div className='mx-[15px] mt-[40px] lg_mx-auto lg_mt-[80px] lg_w-[1100px] lg_max-w-full'>
        <h2 className='font-poppins text-[22px] font-[600] text-title lg_text-[30px]'>Frequently Asked Questions</h2>

        <Accordion
          type='multiple'
          className='mt-[20px] w-full border-t border-[#EFEFEF] lg_mt-[40px]'
          defaultValue={[]}
        >
          <AccordionItem value='item-1'>
            <AccordionTrigger
              headerAsChild
              className='h-[70px] w-full border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px] lg_text-[18px]'
            >
              <p>1. Is the tester program really free?</p>
            </AccordionTrigger>
            <AccordionContent>
              <p className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                Yes, absolutely. If you&apos;re selected, you&apos;ll receive the product at no cost. All we ask is that
                you try it and share your honest feedback.
              </p>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-2'>
            <AccordionTrigger
              headerAsChild
              className='h-[70px] w-full border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px] lg_text-[18px]'
            >
              <p>2. How are testers selected?</p>
            </AccordionTrigger>
            <AccordionContent>
              <p className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                We carefully review all applications and choose testers based on their birding setup, experience, and
                willingness to provide feedback. Due to limited spots, not all applicants will be selected each time.
              </p>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-3'>
            <AccordionTrigger
              headerAsChild
              className='h-[70px] w-full border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px] lg_text-[18px]'
            >
              <p>3. How often do you run product tests?</p>
            </AccordionTrigger>
            <AccordionContent>
              <p className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                We run testing events about once every 1–3 months, depending on our product development schedule. Each
                test usually focuses on a new feeder, pole, or accessory.
              </p>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-4'>
            <AccordionTrigger
              headerAsChild
              className='h-[70px] w-full border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px] lg_text-[18px]'
            >
              <p>4. Will I be notified if I’m selected?</p>
            </AccordionTrigger>
            <AccordionContent>
              <p className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                Yes. If you&apos;re chosen, we’ll contact you by email with details about the product and what to
                expect.
              </p>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-5'>
            <AccordionTrigger
              headerAsChild
              className='h-[70px] w-full border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px] lg_text-[18px]'
            >
              <p>5. Can I apply more than once?</p>
            </AccordionTrigger>
            <AccordionContent>
              <p className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                Yes. Even if you’re not selected this time, you’re welcome to reapply for future testing rounds.
              </p>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value='item-6'>
            <AccordionTrigger
              headerAsChild
              className='h-[70px] w-full border-b-1 border-b-[#EFEFEF] text-left font-poppins font-[600] text-title lg_text-[18px] lg_text-[18px]'
            >
              <p>6. Do I get to keep the product after testing?</p>
            </AccordionTrigger>
            <AccordionContent>
              <p className='border-b-1 border-b-[#EFEFEF] py-[20px] font-sans text-[16px] leading-[1.4] text-title'>
                Yes, you can keep the product after testing.
              </p>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </div>
  );
};

export default ProductTesterPage;
